export enum InventoryCountsOrderField {
  DATE = 'date',
  LOCATION = 'restaurantName',
  STATUS = 'status',
}
